import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MagnifyingGlass = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg",
    };
    return (React.createElement(StyledIconBase, __assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 100 100" }, props, { ref: ref }),
        React.createElement("path", { d: "M56.774 10.391c-17.679 0-32.001 14.329-32.001 32a31.845 31.845 0 004.588 16.517L13.846 74.423l.054.054c-1.656 1.585-2.673 3.835-2.673 6.378-.001 4.913 3.913 8.755 8.821 8.754 2.507-.001 4.749-1.004 6.349-2.636l.039.039 16.008-16.009a31.865 31.865 0 0014.33 3.388c17.68 0 31.999-14.327 31.999-32 0-17.671-14.32-32-31.999-32zm.194 51.417c-11.05 0-20.001-8.954-20.001-20 0-11.044 8.951-20 20.001-20s19.999 8.955 19.999 20c.001 11.046-8.949 20-19.999 20z", key: "k0" })));
});
MagnifyingGlass.displayName = 'MagnifyingGlass';
export var MagnifyingGlassDimensions = { height: 24, width: 24 };
